import BrowserControllerContainer from './browserController'

export default BrowserControllerContainer